import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import EqAffectation from "../../../enums/EqAffectation";
import EqOwner from "../../../enums/EqOwner";
import EqState from "../../../enums/EqState";
import EqMateriovigilance from "../../../enums/EqMateriovigilance";
import EquipmentRowAdmin from "./EquipmentRowAdmin";
import EquipmentModalAdmin from "./EquipmentModalAdmin";
import { deleteEquipment } from "../../../actions/equipments/equipments";
import MaintenancesHistoryModal from "../maintenance/MaintenancesHistoryModal";
import EquipmentAssignModal from "./EquipmentAssignModal";
import Paginator from "../../sub/Paginator";
import InterventionRequestsModal from "../InterventionRequestsModal";
import Util from "../../../util/Util";
import APIUrl from "../../../APIUrl";
import Alert from "react-bootstrap/Alert";
import Icon from "../../sub/Icon";
import MenuButton from "../../sub/bootstrap/MenuButton";
import ModalManager from "../../sub/modals/ModalManager";

class EquipmentsAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      materialsTypesFilter: "",
      brandModelFilter: "",
      floorRoomFilter: "",
      affectationFilter: "",
      warrantyFilter: "",
      purchaseDateFilter: "",
      maintenanceDateFilter: "",
      disinfectionDateFilter: "",
      stateFilter: "",
      ownerFilter: "",
      materiovigilanceFilter: "",
      orderedEquipments: this.props.equipments,
      orderBy: null,
      sortOrder: "ASC",

      modal: null,
    };

    this.paginator = new Paginator(this);
  }

  getMaterialType(materialTypeId) {
    for (let materialType of this.props.materialsTypes) {
      if (materialType._id === materialTypeId) return materialType;
    }
  }

  editEquipment(equipment) {
    let materiovigilance = (
      <h6>
        <span className={"w-100 badge badge-light"}>-</span>
      </h6>
    );

    let materiovigilanceItem = this.props.materiovigilance.filter(
      (materiovigilance) => materiovigilance.model_id === equipment.model_id,
    )[0];
    if (materiovigilanceItem !== undefined) {
      var mvClassName = "";
      if (
        parseInt(materiovigilanceItem.materiovigilance) ===
        EqMateriovigilance.REMINDER
      )
        mvClassName = "danger";
      else if (
        parseInt(materiovigilanceItem.materiovigilance) ===
        EqMateriovigilance.INFOS
      )
        mvClassName = "info";
      else if (
        parseInt(materiovigilanceItem.materiovigilance) ===
        EqMateriovigilance.ALERT
      )
        mvClassName = "warning";
      materiovigilance = (
        <div className={"form-control w-100 alert-" + mvClassName}>
          <h6 className="space-between">
            {this.props.intl.formatMessage({
              id: "EqMateriovigilance." + materiovigilanceItem.materiovigilance,
            })}
            {materiovigilanceItem.doc_url !== undefined &&
              materiovigilanceItem.doc_url !== null && (
                <a
                  role="button"
                  href={
                    APIUrl.getMateriovigilanceFile +
                    materiovigilanceItem._id +
                    "/" +
                    materiovigilanceItem.doc_url.split("/")[
                      materiovigilanceItem.doc_url.split("/").length - 1
                    ] +
                    "?token=" +
                    APIUrl.jwtToken
                  }
                  rel="noopener noreferrer"
                  download={
                    materiovigilanceItem +
                    "." +
                    materiovigilanceItem.doc_url.split("/")[
                      materiovigilanceItem.doc_url.split("/").length - 1
                    ]
                  }
                  target={"_blank"}
                >
                  <Icon
                    className={"icon-small alert-" + mvClassName}
                    icon="download"
                  />
                </a>
              )}
          </h6>
        </div>
      );
    } else {
      materiovigilance = (
        <div className={"form-control w-100 alert-success"}>
          {this.props.intl.formatMessage({ id: "EqMateriovigilance.0" })}
        </div>
      );
    }
    this.setState({
      modal: (
        <EquipmentModalAdmin
          close={() => this.closeModal()}
          establishmentId={this.props.establishmentId}
          materiovigilance={materiovigilance}
          equipmentId={equipment._id}
        />
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  getBrandName(brandId) {
    for (let brand of this.props.brands) {
      if (brand._id === brandId) return brand.name;
    }
  }

  getModelName(modelId) {
    for (let model of this.props.models) {
      if (model._id === modelId) return model.name;
    }
  }

  orderEquipmentsBy(sorting) {
    let sortParam; // will store an array of ordered values for param
    let equipmentParam; // The value to be tested
    let paramIds;

    this.setState({ orderBy: sorting });

    let direction;
    if (this.state.orderBy === sorting) {
      direction = this.state.sortOrder === "DESC" ? "ASC" : "DESC";
    } else {
      direction = "ASC";
    }

    this.setState({ sortOrder: direction });

    switch (sorting) {
      case "brand":
        equipmentParam = "brand_id";
        paramIds = this.props.brands;
        break;
      case "material_type":
        equipmentParam = "material_type_id";
        paramIds = this.props.materialsTypes;
        break;
      case "model_id":
        equipmentParam = "model_id";
        paramIds = this.props.models;
        break;
      default:
        break;
    }

    if (direction === "DESC") {
      sortParam = paramIds.sort((a, b) =>
        a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1,
      );
    } else {
      sortParam = paramIds.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
      );
    }

    sortParam = sortParam.map(function (a) {
      return a._id;
    });

    var ordered = [];

    for (var value of sortParam) {
      for (var equipment of this.props.equipments) {
        if (value === equipment[equipmentParam]) ordered.push(equipment);
      }
    }

    this.setState({ orderedEquipments: ordered });
    // return ordered;
  }

  deleteEquipment(equipment) {
    var content = (
      <React.Fragment>
        <Alert variant="danger">
          <strong>
            <FormattedMessage id="Warning" /> :
          </strong>{" "}
          <FormattedMessage id="Equipment.Delete.Warning.Content" />
        </Alert>
        <p>
          <FormattedMessage id="Equipment.Remove.Confirmation" />
        </p>
      </React.Fragment>
    );
    var successCallback = (e) =>
      this.props.onDeleteEquipment(equipment.establishment_id, {
        equipmentId: equipment._id,
        establishmentId: equipment.establishment_id,
      });

    this.setState({
      modal: (
        <ModalManager
          showModal={true}
          title={<FormattedMessage id={"Confirm"} />}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
          context="danger"
          modalType="confirmation"
        />
      ),
    });
  }

  getEstablishment() {
    for (let establishment of this.props.establishments) {
      if (establishment._id === this.props.establishmentId) {
        return establishment;
      }
    }
  }

  getAdmin() {
    for (var collaborator of this.props.collaborators) {
      if (collaborator.establishments) {
        for (var establishment of collaborator.establishments) {
          if (establishment.establishment_id === this.props.establishmentId)
            return collaborator;
        }
      }
    }
  }

  openAssignModal(equipment) {
    this.setState({
      modal: (
        <EquipmentAssignModal
          equipment={equipment}
          establishment={this.getEstablishment()}
          establishments={this.props.establishments}
          admin={this.getAdmin()}
          openErrorModal={(title, content) =>
            this.openErrorModal(title, content)
          }
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openMaintenancesHistoryModal(equipment, maintenances, establishmentSettings) {
    this.setState({
      modal: (
        <MaintenancesHistoryModal
          equipment={equipment}
          establishment={this.getEstablishment()}
          establishmentSettings={establishmentSettings}
          admin={this.getAdmin()}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openInterventionModal(equipment, establishmentSettings) {
    this.setState({
      modal: (
        <InterventionRequestsModal
          equipment={equipment}
          establishmentSettings={establishmentSettings}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  openErrorModal(title, content) {
    this.setState({
      modal: (
        <ModalManager
          showModal={true}
          title={title}
          content={content}
          closeModal={() => this.closeModal()}
          buttonLabel={<FormattedMessage id="Close" />}
          modalType="error"
        />
      ),
    });
  }

  areResultsFiltered = () => {
    if (
      !Util.emptyString(this.state.materialsTypesFilter) ||
      !Util.emptyString(this.state.brandModelFilter) ||
      !Util.emptyString(this.state.floorRoomFilter) ||
      !Util.emptyString(this.state.affectationFilter) ||
      !Util.emptyString(this.state.warrantyFilter) ||
      !Util.emptyString(this.state.purchaseDateFilter) ||
      !Util.emptyString(this.state.maintenanceDateFilter) ||
      !Util.emptyString(this.state.disinfectionDateFilter) ||
      !Util.emptyString(this.state.stateFilter) ||
      !Util.emptyString(this.state.ownerFilter) ||
      !Util.emptyString(this.state.materiovigilanceFilter) ||
      this.props.pendingDeliveryFilter ||
      this.props.pendingRecoveryFilter
    ) {
      return true;
    } else {
      return false;
    }
  };

  resetSearchFields() {
    this.setState({
      materialsTypesFilter: "",
      brandModelFilter: "",
      floorRoomFilter: "",
      affectationFilter: "",
      warrantyFilter: "",
      purchaseDateFilter: "",
      maintenanceDateFilter: "",
      disinfectionDateFilter: "",
      stateFilter: "",
      ownerFilter: "",
      materiovigilanceFilter: "",
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.equipments !== this.props.equipments) {
      this.setState({ orderedEquipments: this.props.equipments });
      // Reset paginator to page 1 if props.equipments did update
      this.paginator.paginationIndex = 1;
    }
  }

  render() {
    if (!this.props.equipments || this.props.equipments.length === 0)
      return null;

    var materialsTypesNode = this.props.materialsTypes.map((materialTypeId) => {
      return (
        <option key={materialTypeId._id} value={materialTypeId._id}>
          {materialTypeId.name}
        </option>
      );
    });

    var affectationsNode = Object.values(EqAffectation).map((option) => {
      return (
        <option key={option} value={option}>
          {this.props.intl.formatMessage({ id: "EqAffectation." + option })}
        </option>
      );
    });

    var ownerNode = Object.values(EqOwner).map((option) => {
      return (
        <option key={option} value={option}>
          {this.props.intl.formatMessage({ id: "EqOwner." + option })}
        </option>
      );
    });

    var stateNode = Object.values(EqState).map((option) => {
      return (
        <option key={option} value={option}>
          {this.props.intl.formatMessage({ id: "EqState." + option })}
        </option>
      );
    });

    var materiovigilanceNode = Object.values(EqMateriovigilance).map(
      (option) => {
        return (
          <option key={option} value={option}>
            {this.props.intl.formatMessage({
              id: "EqMateriovigilance." + option,
            })}
          </option>
        );
      },
    );

    this.paginator.init(this.props.equipments.length);

    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    this.state.orderedEquipments.sort((a, b) => {
      if (this.state.floorRoomFilter === "") {
        return 0;
      } else if (
        a.room === this.state.floorRoomFilter.toLowerCase() ||
        a.floor === this.state.floorRoomFilter.toLowerCase()
      ) {
        return -1;
      } else if (
        b.room === this.state.floorRoomFilter.toLowerCase() ||
        b.floor === this.state.floorRoomFilter.toLowerCase()
      ) {
        return 1;
      } else {
        return 0;
      }
    });

    let equipmentsNode = this.state.orderedEquipments.map((equipment) => {
      let maintenances = [];
      let requests = [];
      let establishmentSettings;
      for (let es of this.props.establishmentsSettings) {
        if (es.establishment_id === equipment.establishment_id) {
          establishmentSettings = es;
        }
      }
      for (var maintenance of this.props.maintenances) {
        if (maintenance.equipment_id === equipment._id) {
          if (maintenance.establishment_id === equipment.establishment_id) {
            maintenances.push(maintenance);
          }
        }
      }

      for (var request of this.props.requests) {
        if (request.equipment_id === equipment._id) {
          if (request.establishment_id === equipment.establishment_id) {
            requests.push(request);
          }
        }
      }

      // Get last maintenance date to allow filter on it
      let lastMaintenanceDate = null;
      if (maintenances.length > 0) {
        lastMaintenanceDate =
          maintenances[maintenances.length - 1].creation_date;
      }

      if (
        this.state.materialsTypesFilter &&
        this.state.materialsTypesFilter !== ""
      ) {
        if (equipment.material_type_id !== this.state.materialsTypesFilter)
          return null;
      }

      if (this.state.brandModelFilter && this.state.brandModelFilter !== "") {
        var brandName = this.getBrandName(equipment.brand_id);
        var modelName = this.getModelName(equipment.model_id);

        if (!equipment.serial_nbr) {
          equipment.serial_nbr = "";
        }

        if (
          !brandName ||
          !modelName ||
          !equipment.internal_ref ||
          (brandName.toLowerCase().indexOf(this.state.brandModelFilter) ===
            -1 &&
            modelName.toLowerCase().indexOf(this.state.brandModelFilter) ===
              -1 &&
            equipment.serial_nbr
              .toLowerCase()
              .indexOf(this.state.brandModelFilter) === -1 &&
            equipment.internal_ref
              .toLowerCase()
              .indexOf(this.state.brandModelFilter) === -1)
        ) {
          return null;
        }
      }

      if (this.state.floorRoomFilter && this.state.floorRoomFilter !== "") {
        let notCommunicated = "nc"; // si le psdm tape NC
        if (notCommunicated === this.state.floorRoomFilter.toLowerCase()) {
          if (
            !(
              !equipment.room ||
              equipment.room === "" ||
              !equipment.floor ||
              equipment.floor === ""
            )
          )
            return null;
        } else {
          if (
            !(
              equipment.room &&
              equipment.room
                .toLowerCase()
                .startsWith(this.state.floorRoomFilter.toLowerCase())
            ) &&
            !(
              equipment.floor &&
              equipment.floor
                .toLowerCase()
                .startsWith(this.state.floorRoomFilter.toLowerCase())
            )
          ) {
            return null;
          }
        }
      }

      if (this.state.affectationFilter && this.state.affectationFilter !== "") {
        if (
          parseInt(equipment.affectation) !==
          parseInt(this.state.affectationFilter)
        )
          return null;
      }

      if (
        this.state.purchaseDateFilter &&
        this.state.purchaseDateFilter !== ""
      ) {
        if (
          !equipment.purchase_date ||
          new Date(equipment.purchase_date) <
            new Date(this.state.purchaseDateFilter)
        )
          return null;
      }

      if (
        this.state.maintenanceDateFilter &&
        this.state.maintenanceDateFilter !== ""
      ) {
        if (
          null === lastMaintenanceDate ||
          new Date(lastMaintenanceDate).setHours(0, 0, 0, 0) >
            new Date(this.state.maintenanceDateFilter).setHours(0, 0, 0, 0)
        )
          return null;
      }

      if (
        this.state.disinfectionDateFilter &&
        this.state.disinfectionDateFilter !== ""
      ) {
        if (
          !equipment.disinfection_date ||
          new Date(equipment.disinfection_date).setHours(0, 0, 0, 0) <
            new Date(this.state.disinfectionDateFilter).setHours(0, 0, 0, 0)
        )
          return null;
      }

      if (this.state.warrantyFilter && this.state.warrantyFilter !== "") {
        var equipmentWarranty =
          equipment.warranty !== undefined && equipment.warranty !== null
            ? equipment.warranty
            : false;
        if (equipmentWarranty !== JSON.parse(this.state.warrantyFilter))
          return null;
      }

      if (this.state.stateFilter && this.state.stateFilter !== "") {
        if (
          equipment.state === undefined ||
          parseInt(equipment.state) !== parseInt(this.state.stateFilter)
        )
          return null;
      }

      if (this.state.ownerFilter && this.state.ownerFilter !== "") {
        if (
          equipment.owner === undefined ||
          parseInt(equipment.owner) !== parseInt(this.state.ownerFilter)
        )
          return null;
      }

      var materiovigilance = undefined;

      for (var materiovigilances of this.props.materiovigilance) {
        if (materiovigilances.model_id === equipment.model_id) {
          materiovigilance = materiovigilances.materiovigilance;
        }
      }

      if (
        this.state.materiovigilanceFilter !== "" &&
        this.state.materiovigilanceFilter !== undefined
      ) {
        if (
          parseInt(this.state.materiovigilanceFilter) !==
          parseInt(materiovigilance)
        ) {
          return null;
        }
      }

      // Filtre pour les équipements à livrer
      if (this.props.pendingDeliveryFilter) {
        if (!equipment.pending_delivery) return null;
      }

      // Filtre pour les équipements à récupérer
      if (this.props.pendingRecoveryFilter) {
        if (!equipment.pending_recovery) return null;
      }

      if (!this.paginator.keep()) return null;

      return (
        <EquipmentRowAdmin
          key={equipment._id}
          equipment={equipment}
          materiovigilance={materiovigilance}
          maintenances={maintenances}
          requests={requests}
          maintenanceToSign={this.props.maintenancesToSign}
          establishmentId={this.props.establishmentId}
          openInterventionModal={(equipment) =>
            this.openInterventionModal(equipment, establishmentSettings)
          }
          editEquipment={(equipment) => this.editEquipment(equipment)}
          deleteEquipment={(equipment) => this.deleteEquipment(equipment)}
          openMaintenanceModal={(equipment) =>
            this.openMaintenanceModal(equipment)
          }
          openMaintenancesHistoryModal={(equipment) =>
            this.openMaintenancesHistoryModal(
              equipment,
              maintenances,
              establishmentSettings,
            )
          }
          openAssignModal={(equipment) => this.openAssignModal(equipment)}
        />
      );
    });

    return (
      <React.Fragment>
        <table id="equipments" className="table tablee4coll">
          <thead>
            <tr className="d-flex align-items-center h-100">
              <th scope="col" className="col">
                <span
                  className="btn-link cursor-pointer"
                  onClick={() => this.orderEquipmentsBy("material_type")}
                >
                  <strong>
                    <FormattedMessage id="Type" />
                  </strong>
                </span>
              </th>
              <th scope="col" className="col" style={{ overflow: "visible" }}>
                <span
                  className="btn-link cursor-pointer"
                  onClick={() => this.orderEquipmentsBy("brand")}
                >
                  <strong>
                    <FormattedMessage id="Brand" />
                  </strong>
                </span>{" "}
                /{" "}
                <span
                  className="btn-link cursor-pointer"
                  onClick={() => this.orderEquipmentsBy("model_id")}
                >
                  <strong>
                    <FormattedMessage id="Model" />
                  </strong>
                </span>
              </th>
              <th scope="col" className="col-auto" style={{ width: "100px" }}>
                <FormattedMessage id="Location" />
              </th>
              <th scope="col" className="col-auto text-center" style={{ width: "80px" }}>
                <FormattedMessage id="Affectation" />
              </th>
              <th scope="col" className="col-auto text-center" style={{ width: "80px" }}>
                <FormattedMessage id="Warranty" />
              </th>
              <th scope="col" className="col text-center">
                <FormattedMessage id="Last.Maintenance.Date" />
              </th>
              <th scope="col" className="col text-center">
                Date de désinfection
              </th>
              <th scope="col" className="col text-center">
                <FormattedMessage id="State" />
              </th>
              <th scope="col" className="col text-center">
                <FormattedMessage id="Owner" />
              </th>
              <th scope="col" className="col text-center">
                <FormattedMessage id="Materiovigilance" />
              </th>
              <th scope="col" className="col text-center">
                <FormattedMessage id="Actions" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              id="equipmentsFilters"
              className="d-flex align-items-center h-100"
            >
              <td className="col">
                <select
                  className="form-control"
                  value={this.state.materialsTypesFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ materialsTypesFilter: e.target.value });
                  }}
                >
                  <option value="">
                    {this.props.intl.formatMessage({ id: "All" })}
                  </option>
                  {materialsTypesNode}
                </select>
              </td>
              <td className="col">
                <input
                  className="form-control"
                  type="text"
                  value={this.state.brandModelFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({
                      brandModelFilter: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </td>
              <td className="col-auto" style={{ width: "100px" }}>
                <input
                  className="form-control"
                  type="text"
                  value={this.state.floorRoomFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ floorRoomFilter: e.target.value });
                  }}
                />
              </td>
              <td className="col-auto" style={{ width: "80px" }}>
                <select
                  className="form-control"
                  value={this.state.affectationFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ affectationFilter: e.target.value });
                  }}
                >
                  <option value="">
                    {this.props.intl.formatMessage({ id: "All" })}
                  </option>
                  {affectationsNode}
                </select>
              </td>
              <td className="col-auto" style={{ width: "80px" }}>
                <select
                  className="form-control"
                  value={this.state.warrantyFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ warrantyFilter: e.target.value });
                  }}
                >
                  <option value="">
                    {this.props.intl.formatMessage({ id: "All" })}
                  </option>
                  <option value="true">
                    {this.props.intl.formatMessage({ id: "Yes" })}
                  </option>
                  <option value="false">
                    {this.props.intl.formatMessage({ id: "No" })}
                  </option>
                </select>
              </td>
              <td className="col">
                <input
                  className="form-control"
                  type="date"
                  value={this.state.maintenanceDateFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ maintenanceDateFilter: e.target.value });
                  }}
                />
              </td>
              <td className="col">
                <input
                  className="form-control"
                  type="date"
                  value={this.state.disinfectionDateFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ disinfectionDateFilter: e.target.value });
                  }}
                />
              </td>
              <td className="col">
                <select
                  className="form-control"
                  value={this.state.stateFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ stateFilter: e.target.value });
                  }}
                >
                  <option value="">
                    {this.props.intl.formatMessage({ id: "All" })}
                  </option>
                  {stateNode}
                </select>
              </td>
              <td className="col">
                <select
                  className="form-control"
                  value={this.state.ownerFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ ownerFilter: e.target.value });
                  }}
                >
                  <option value="">
                    {this.props.intl.formatMessage({ id: "All" })}
                  </option>
                  {ownerNode}
                </select>
              </td>
              <td className="col">
                <select
                  className="form-control"
                  value={this.state.materiovigilanceFilter}
                  disabled={disableFormInput}
                  onChange={(e) => {
                    this.setState({ materiovigilanceFilter: e.target.value });
                  }}
                >
                  <option value="">
                    {this.props.intl.formatMessage({ id: "All" })}
                  </option>
                  {materiovigilanceNode}
                </select>
              </td>
              <td className="col text-center">
                <MenuButton
                  onClick={() => this.resetSearchFields()}
                  hover={
                    this.areResultsFiltered() &&
                    !disableFormInput && <FormattedMessage id="Remove.Filter" />
                  }
                  variant={
                    this.areResultsFiltered() ? "warning" : "outline-secondary"
                  }
                  icon="filter"
                  disabled={!this.areResultsFiltered() || disableFormInput}
                />
              </td>
            </tr>
            {equipmentsNode}
          </tbody>
        </table>

        {this.paginator.render()}

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    materialsTypes: state.materialsTypes,
    brands: state.brands,
    models: state.models,
    establishments: state.establishments,
    establishmentsSettings: state.establishmentsSettings,
    collaborators: state.collaborators,
    maintenances: state.maintenances,
    requests: state.requests,
    materiovigilance: state.materiovigilance,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDeleteEquipment: (establishmentId, data) =>
      dispatch(deleteEquipment(establishmentId, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EquipmentsAdmin));
